import { PipRunName } from 'interfaces/jobs/pipsRunNames';
import { apiRequestHandlerPromise } from 'utils/apiRequestHandler';

export const getPipRunNames = () => {
  return apiRequestHandlerPromise<PipRunName[]>({
    url: `pips-run-names`,
    method: 'GET',
  });
};
